import axios from "axios";
const authConfig = {
	domain: process.env.VUE_APP_AUTH_CONFIG_DOMAIN,
	clientId: process.env.VUE_APP_AUTH_CONFIG_CLIENTID,
	audience: process.env.VUE_APP_AUTH_CONFIG_AUDIENCE
};

const apiClient = axios.create({
	baseURL: process.env.VUE_APP_BASE_URL + "/api",
	withCredentials: false, // This is the default
	headers: {
		Accept: "application/json",
		"Content-Type": "application/json"
	}
});

const authApiClient = axios.create({
	baseURL: `https://${authConfig.domain}`
});

export default {
	setAxiosBearerHeader(bearerToken) {
		// https://github.com/axios/axios/issues/209
		apiClient.defaults.headers["Authorization"] = `Bearer ${bearerToken}`;
		authApiClient.defaults.headers["Authorization"] = `Bearer ${bearerToken}`;
	},
	fetchUserData() {
		return apiClient.get("/thisUser");
	},
	getRecords() {
		return apiClient.get("/records");
	},
	newRecord(record) {
		return apiClient.post("/records", record);
	},
	deleteRecord(recordID) {
		return apiClient.delete("/records/" + recordID);
	},
	addEmployee(employeeDetailsPayload) {
		return apiClient.post("/employees/add", employeeDetailsPayload);
	},
	deleteEmployee(employeeDetailsPayload) {
		return apiClient.post("/employees/delete", employeeDetailsPayload);
	},
	editEmployee(employeeDetailsPayload) {
		return apiClient.post("/employees/edit", employeeDetailsPayload);
	},
	uploadFace(formData) {
		return apiClient.post("/employees/face/upload", formData);
	},
	recognizeFace(formData) {
		return apiClient.post("/employees/face/recognize", formData);
	},
	startEmailNotifications({ org, email }) {
		return apiClient.post("/notify/email/subscribe", { org, email });
	},
	stopEmailNotifications({ org, email }) {
		return apiClient.post("/notify/email/unsubscribe", { org, email });
	},
	fulfillUpdateRequest() {
		return apiClient.get("/fulfillUpdateRequest");
	},
	calibrateSensor(deviceID, direction) {
		return apiClient.get(`/device/${deviceID}/calibrate/offset/${direction}`);
	},
	calibrateSensorDirect(deviceID, directCalibration) {
		return apiClient.post(`/device/${deviceID}/calibrate/direct`, { directCalibration });
	},

	// Auth0 API Calls
	changePassword(email, connection) {
		return authApiClient.post("/dbconnections/change_password", {
			client_id: authConfig.clientId,
			email,
			connection
		});
	},

	demoSimulateDevice() {
		return apiClient.post(`/device`, {
			DEVICE_ID: 1,
			DEVICE_PASSCODE: "123",
			ATEMP: 80,
			OTEMP: (97 + Math.random() * 2).toFixed(2),
			DIST: 5
		});
	}
};
